export default "__VITE_ASSET__KunlpWYO__"